// Env loaded from pod start, more info https://medium.com/codex/update-angular-react-environment-dynamically-reading-variables-from-kubernetes-configmaps-ae32b8d4021c

import { EnvironmentDefinition, WindowDefinition } from './types';

let data = (window as unknown as WindowDefinition).env;
if (!data) {
  data = {
    production: true,
    api: 'https://api.dev.sisem.co',
    authService: 'https://admin.dev.sisem.co/auth',
    keycloakRealm: 'sisem',
    keycloakClient: 'sisem_real_operations_front',
    firebasePushConfig: null as unknown as EnvironmentDefinition['firebasePushConfig'],
    socketServer: 'http://18.209.140.119:2890',
    azureClientId: '',
    azureAuthorityUrl: '',
    knownAuthorities: '',
    azureRedirectUri: '',
    mobileUrl: '',
    mobileUrl_core: '',
    googleApiKey: '',
    geoserver: '',
    geoserverWorkspace: '',
    mapBoxTemplate: '',
  };
}

export const environment: EnvironmentDefinition = {
  production: data.production,
  keycloakClient: data.keycloakClient,
  api: data.api,
  authService: data.authService,
  azureRedirectUri: data.azureRedirectUri,
  azureClientId: data.azureClientId,
  azureAuthorityUrl: data.azureAuthorityUrl,
  knownAuthorities: data.knownAuthorities,
  mobileUrl: data.mobileUrl,
  mobileUrl_core: data.mobileUrl_core,
  socketServer: data.socketServer,
  googleApiKey: data.googleApiKey,
  firebasePushConfig: {
    apiKey: '-',
    authDomain: '-',
    projectId: '-',
    storageBucket: '-',
    messagingSenderId: '-',
    appId: '-',
    measurementId: '-',
    vapidKey: '-',
  },
  geoserver: data.geoserver,
  geoserverWorkspace: data.geoserverWorkspace,
  keycloakRealm: data.keycloakRealm,
  mapBoxTemplate: data.mapBoxTemplate,
};
if (!environment.api) {
  alert('Error desconocido, no se pudo obtener variables de entorno');
}
